
import { EcomService } from "~/services/ecom.service";
import type { APIState } from "~/types/api-state.type";
import type { Brands } from "~/types/builder-brands.type";

export const useBrandStore = defineStore('brand', {
    state: () => ({
        builder_api_key: useRuntimeConfig().public.builderApiKey,
        activeComponent: null,
        layout: 'brand-plp',
        brandSlug: null,
        activeTab: 'about',
        brands: <Brands>{},
        all_brands: {},
        specialBrand: <boolean>false,
        brandName: <string>'',
        builderBrandPage: <any>{}
    }),
    actions: {
        async getBrands() {
            const { getBrands } = await import('~/stores-datalayer/brand.datalayer');
            return await getBrands();
        },

        async getAllBrands() {
            const { getAllBrands } = await import('~/stores-datalayer/brand.datalayer');
            return await getAllBrands();
        },

        async handleBrandCardClick(brandName: string) {
            const { handleBrandCardClick } = await import('~/stores-datalayer/brand.datalayer');
            return await handleBrandCardClick(brandName);
        },

        async brandPageInit() {
           
            const { brandPageInit } = await import('~/stores-datalayer/brand.datalayer');
            return await brandPageInit();
        }
    },

})